import React, { Component } from 'react'
import ContainerHeader from 'components/ContainerHeader/index'
import SearchProductionRecipeContainer from './containers/SearchProductionRecipe'

class SearchProductionRecipe extends Component {
  render() {
    return (
      <div className="app-wrapper">
        <ContainerHeader
          location={this.props.location}
          title="Buscar Receitas de Produção"
        />
        <SearchProductionRecipeContainer />
      </div>
    )
  }
}

export default SearchProductionRecipe
